import { Component, Injector, ViewEncapsulation, OnInit, ViewChild, Output, Input, EventEmitter } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';

import * as _ from 'lodash-es';

import { Paginator } from 'primeng/paginator';
import { Table } from 'primeng/table';
import { LazyLoadEvent } from 'primeng/api';

import { ColumnDefinition } from '@app/shared/common/shop-system/models/models';
import { AppConsts } from '@shared/AppConsts';

@Component({
    selector: 'app-search-and-select',
    templateUrl: './search-and-select.component.html',
    styleUrls: ['./search-and-select.component.less'],
    encapsulation: ViewEncapsulation.None,
})
export class SearchAndSelectComponent<T> extends AppComponentBase implements OnInit {
    @ViewChild('dataTable', { static: true }) dataTable: Table;
    @ViewChild('paginator', { static: true }) paginator: Paginator;

    remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;

    //#region Props
    @Input() isIgnoreId = true;

    @Input() searchLabel: string;

    private _instance: T;
    set instance(value: T) {
        this._instance = value;

        this._initCols();
    }
    get instance(): T {
        return this._instance;
    }

    private _data: T[];
    @Input() set data(value: T[]) {
        this._data = value;

        this._setTable();
    }
    get data(): T[] {
        return this._data;
    }

    private _total: number;
    @Input() set total(value: number) {
        this._total = value;

        this._setTable();
    }
    get total(): number {
        return this._total;
    }

    private _columns: ColumnDefinition[];
    @Input() set columns(value: ColumnDefinition[]) {
        this._columns = value;

        this._initCols();
    }
    get columns(): ColumnDefinition[] {
        return this._columns;
    }

    cols: any[] = [];
    //#endregion

    @Output() onSearch: EventEmitter<any> = new EventEmitter<any>();
    @Output() onRowSelect: EventEmitter<any> = new EventEmitter<any>();
    @Output() onRowUnselect: EventEmitter<any> = new EventEmitter<any>();
    @Output() onPagination: EventEmitter<any> = new EventEmitter<any>();

    searchString: string;
    itemsSelected: T[] = [];

    constructor(
        injector: Injector
    ) {
        super(injector);

        this.primengTableHelper.defaultRecordsCountPerPage = 10;
        this.primengTableHelper.predefinedRecordsCountPerPage = [10, 25, 50, 100];
    }

    ngOnInit(): void {
        this.primengTableHelper.defaultRecordsCountPerPage = 10;
    }

    setFields(dashboard) {
        this.cols = [];
        dashboard = dashboard.value;
        if (dashboard) {
            let cols = dashboard.logDashboardField;
            _.forEach(cols, (col) => {
                this._addColumn(col.fieldSource, col.displayName, col.type);
            });

            this._setTable();
        }
    }

    private _initCols() {
        this.cols = [];
        let columns: any[] = [];

        if (this.columns && this.columns.length > 0) {
            columns = this.columns;
            _.each(columns,
                (column: ColumnDefinition) => {
                    this._addColumn(column.field, column.header, column.type, column.height, column.colWidth, column.sorting);
                });
        } else {
            columns = _.keys(this.instance);
            _.each(columns,
                (column) => {
                    this._addColumn(column, column, undefined);
                });
        }
    }

    private _initColsTypes() {
        let fields = _.keys(this.instance);
    }

    private _setTable() {
        if (this.data) {
            this.primengTableHelper.records = this.data;
            this.primengTableHelper.totalRecordsCount = this.total;
        }
    }

    private _addColumn(field, header, type, height?: any, width?: any, sorting: boolean = false) {

        if (this.isIgnoreId && field === 'id') {
            return;
        }

        if (field && header) {
            header = _.camelCase(header);
            let lHeader = this.l(`Axilla${this.className}.${header}`, 'Axilla');

            let obj = { field: field, header: lHeader, type: type || undefined, height: height || undefined, width: width || undefined, sorting: sorting  };
            this.cols.push(obj);
        }
    }

    get className(): string {
        if (!this.instance) { return ''; }

        return `.${this.instance.constructor.name}`;
    }

    //#region Events
    onSearching() {
        this.onSearch.emit(this.searchString);
    }

    clear() {
        this.searchString = '';
    }

    onPageChange(event?: LazyLoadEvent) {
        let pagination = {
            sorting: this.primengTableHelper.getSorting(this.dataTable),
            maxResultCount: this.primengTableHelper.getMaxResultCount(this.paginator, event),
            skipCount: this.primengTableHelper.getSkipCount(this.paginator, event),
        };

        this.onPagination.emit(pagination);
    }

    onRowSelection(item: T) {
        this.onRowSelect.emit(this.itemsSelected);
    }
    onRowUnSelection(item: T) {
        this.onRowUnselect.emit(this.itemsSelected);
    }
    //#endregion Events

}
